import React, { ReactNode } from "react";
import { Divider, Toolbar, Typography } from "@mui/material";

interface IPanelProps {
  title: String | ReactNode;
  children: ReactNode;
}

const Panel = ({ title, children }: IPanelProps) => {
  return (
    <div className="flex h-full w-full flex-col rounded-2xl bg-white pt-2 shadow-lg">
      <Toolbar variant="dense">
        <Typography variant="h6" className="m-0 w-full">
          {title}
        </Typography>
      </Toolbar>
      <Divider />
      <div className="flex flex-grow flex-col overflow-y-auto px-6 py-6">
        {children}
      </div>
    </div>
  );
};

export default Panel;
